<div class="content">
  <div class="login sign-up">
    <div class="login-logo-odm">
      <img src="{{logoPath}}">
    </div>
    <form (ngSubmit)="registerAccount(registerAccountForm)" #registerAccountForm="ngForm">
      <div class="login-content">
        <h3><span>{{'Registration' | translate}}</span>{{'Enter your details to create your account:' | translate}}</h3>
        <div class="form-group">
          <label for="" class="col-form-label" translate>First Name</label>
          <div>
            <input type="text" pInputText class="pInputText" [(ngModel)]="RegisterAccountInfo.FirstName" name="FirstName" #firstName="ngModel" required>
            <p-message severity="error" text="{{'First Name is required' | translate}}" *ngIf="(registerAccountForm.submitted && !firstName.dirty) || (firstName.invalid && (firstName.dirty || firstName.touched))">
            </p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label" translate>Last Name</label>
          <div>
            <input type="text" pInputText class="pInputText" [(ngModel)]="RegisterAccountInfo.LastName" name="LastName" #lastName="ngModel" required>
            <p-message severity="error" text="{{'Last Name is required' | translate}}" *ngIf="(registerAccountForm.submitted && !lastName.dirty) || (lastName.invalid && (lastName.dirty || lastName.touched))">
            </p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label">{{'Account ID' | translate}} <small>({{'Email Address' | translate}})</small></label>
          <div>
            <input type="text" pInputText class="pInputText" [(ngModel)]="RegisterAccountInfo.Account" name="Account" required
                   pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #account="ngModel">
            <p-message severity="error" text="{{'Account ID is invalid' | translate}}" *ngIf="(registerAccountForm.submitted && !account.dirty) || (account.invalid && (account.dirty || account.touched))"></p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label" translate>Country</label>
          <div>
            <p-select [options]="CountryOptions" [(ngModel)]="RegisterAccountInfo.Country" name="Country" #country="ngModel"></p-select>
            <p-message severity="error" text="{{'Country is required' | translate}}" *ngIf="(registerAccountForm.submitted &&  !country.value) || (!country.value && (country.dirty || country.touched))"></p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label" translate>Set Your Password</label>
          <div>
            <!-- <input type="password" pPassword id="password" class="pInputText" [(ngModel)]="RegisterAccountInfo.Password" name="Password" #password="ngModel" required> -->
            <div class="inputpassword">
              <input type="{{inputType}}" pPassword id="password" class="pInputText" [(ngModel)]="RegisterAccountInfo.Password" name="Password" #password="ngModel" required (ngModelChange)="passwordChange(password.value)">
              <p-toggleButton class="passwordIcon" onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onLabel="pi-eye" offLabel="pi-eye" (onChange)="handleChange($event)" *ngIf="showPasswordIcon"></p-toggleButton>
            </div>
            <p-message severity="error" text="{{'Password is required' | translate}}" *ngIf="(registerAccountForm.submitted && !password.dirty) || (password.invalid && (password.dirty || password.touched))">
            </p-message>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="col-form-label" translate>Confirm Your Password</label>
          <div>
            <!-- <input type="password" pPassword id="passwordConfirm" class="pInputText" [(ngModel)]="PasswordConfirm" name="PasswordConfirm" #passwordConfirm="ngModel" required> -->
            <div class="inputpassword">
              <input type="{{inputTypeConfirm}}" pPassword id="passwordConfirm" class="pInputText" [(ngModel)]="PasswordConfirm" name="PasswordConfirm" #passwordConfirm="ngModel" required (ngModelChange)="passwordConfirmChange(passwordConfirm.value)">
              <p-toggleButton class="passwordIcon" onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onLabel="pi-eye" offLabel="pi-eye" (onChange)="handleConfirmChange($event)" *ngIf="showPasswordIconConfirm"></p-toggleButton>
            </div>
            <p-message severity="error" text="{{'Password does not match' | translate}}"
                       *ngIf="(passwordConfirm.value!=password.value && (passwordConfirm.touched) || (registerAccountForm.submitted && password.valid && !passwordConfirm.touched))"></p-message>
          </div>
        </div>
        <div class="form-group">
          <div>
            <p-checkbox name="PrivacyPolicy" [(ngModel)]="AgreePrivacyPolicy" value="agree"></p-checkbox>
            <span>{{'I agree to the' | translate}} <a [routerLink]="'/' + shareModel.urlPath.TermsAndConditions" target="_blank">{{'Terms & Conditions' | translate}}</a> | <a [routerLink]="'/' + shareModel.urlPath.PrivacyPolicy"
                 target="_blank">{{'Privacy Policy' | translate}}</a></span>
            <p-message severity="error" text="{{'Please agree to the Terms & Conditions | Privacy Policy.' | translate}}" *ngIf="registerAccountForm.submitted && !AgreePrivacyPolicy.length"></p-message>
          </div>
        </div>
        <!-- <p-message severity="error" text="Login Fail."></p-message> -->
        <button type="submit" pButton label="{{'SIGN UP' | translate}}" class="login-btn" name="submit"></button>
        <div class="sign">
          {{'Already have and account ?' | translate}}
          <a href="/login" class=""> {{'Login' | translate}}</a>
        </div>
      </div>
    </form>
  </div>
</div>


<!-- 申請帳號後，跳出提示視窗：請至註冊email信箱點選確認信連結始完成註冊流程 -->
<p-dialog header="{{'Information' | translate}}" [(visible)]="displayInfoDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog">
  <div class="dialog-content">
    <h5 translate>Thanks for registering with us.</h5>
    <p translate>An email has been sent to you with a link to activate your account. Please noted that the activation link is valid for 7 days. If registration process is not complete in 7 days,  you will need to sign up again.
    </p>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="closeDialog();" label="{{'OK' | translate}}" class="login-btn"></button>
  </ng-template>
</p-dialog>
